import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { AccountService } from 'src/app/services/account.service';
import { CouponService } from 'src/app/services/coupon.service';
import { CustomValidatorService } from 'src/app/services/custom-validator.service';
import { projectConstants } from 'src/app/shared/constants/project-constants';
import moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatOption } from '@angular/material/core';

@Component({
  selector: 'app-create-coupon-dialog',
  templateUrl: './create-coupon-dialog.component.html',
  styleUrls: ['./create-coupon-dialog.component.css']
})
export class CreateCouponDialogComponent implements OnInit {
  domains: any = [];
  domain: any;
  license_packages: any = [];
  subDomains: any = [];
  selectedDomains: any = [];
  api_error: any;
  api_success: string;
  maxLimitperProvider = true;
  title = 'CREATE';
  allSelected: any;
  accountInfo: any;
  hide_specific_provider_info = true;
  hideCheckbtn = true;
  providerIds: any = [];
  accounts: any = [];
  showSubDomain = false;
  hideConsumerLimit = false;
  weekdays = projectConstants.myweekdaysSchedule;
  selday_arr: any = [];
  selallweekdays = false;
  couponId: any;
  action: any;
  couponDetails: any;
  dstart_time;
  dend_time;
  Selall = false;
  public couponForm: UntypedFormGroup;
  constructor(private formbuilder: UntypedFormBuilder,
    private commonService: CommonfilterService,
    private accountService: AccountService,
    private matDialog: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any,
    private couponService: CouponService, private customValidator: CustomValidatorService) {

    this.createForm();
   
    // update coupon
    if (this.data['type'] === 'edit') {
      // coupon code is non-editable once it is created
      this.couponForm.get('jaldeeCouponCode').disable();
      if (this.data['status'] === 'ACTIVE') {
        // we can edit only some fields if coupon is pushed(ie; active)
        this.couponForm.disable();
        this.couponForm.get('couponRules').get('endDate').enable();
        this.couponForm.get('couponName').enable();
        this.couponForm.get('consumerTermsAndconditions').enable();
        this.couponForm.get('providerDescription').enable();
        this.couponForm.get('couponDescription').enable();
        this.couponForm.get('couponRules').get('qstarttime').enable();
        this.couponForm.get('couponRules').get('qendtime').enable();
      }
      this.updateForm(this.data['couponDetails']);
      this.title = 'UPDATE';
    }
    // console.log(this.data['status']);
    // if (this.data['status'] !== 'ACTIVE') {
    //   this.couponForm.get('maxReimbursePercentage').setValue('100');
    //     }
  }


  @ViewChild('allLicenseSelected', {static: false}) private allLicenseSelected: MatOption;
  @ViewChild('allDomainSelected', {static: false}) private allDomainSelected: MatOption;
  @ViewChild('allSubDomainSelected', {static: false}) private allSubDomainSelected: MatOption;



  formErrors = {
    'couponName': '',
    'jaldeeCouponCode': '',
    'discountValue': '',
    'startDate': '',
    'endDate': '',
    'validDate': '',
    'minBillAmount': '',
    'couponDescription': '',
    'providerDescription': '',
    'consumerTermsAndconditions': '',
    'discountType': '',
    'maxDiscountValue': '',
    'maxReimbursePercentage': '',
    'maxConsumerUseLimit': '',
    'maxConsumerUseLimitPerProvider': '',
    'maxProviderUseLimit': ''



  };
  ValidationMessages = {
    'couponName': {
      'required': 'Coupon Name is Required',
      'minlength': 'Coupon Name should have a minimum length of 3 characters',
      'whitespace': 'Coupon Name is invalid'

    },
    'consumerTermsAndconditions': {
      'required': 'Consumer T&C is Required',
      'whitespace': 'Consumer T&C  is invalid'
    },
    'couponDescription': {
      'required': 'Coupon Description is Required',
      'whitespace': 'Coupon Description is invalid'
    },
    'providerDescription': {
      'required': 'Provider Description is Required',
      'whitespace': 'Provider Description is invalid'
    },
    'jaldeeCouponCode': {
      'required': 'Coupon Code is Required',
      'minlength': 'Coupon Code should have a minimum length of 3 characters',
      'maxlength': 'Coupon Code should only have a maximum length of 15 characters',
      'pattern': 'Only letters and numbers are allowed',
      'whitespace': 'Coupon Code is invalid'

    },
    'discountValue': {
      'required': 'value is required',
      'zeroOrnegativeNumber': 'Zero or Negative numbers are  not allowed'
    },

    'minBillAmount': {
      'required': ' Minimum bill amount is required',
      'zeroOrnegativeNumber': 'Zero or Negative numbers are  not allowed'
    },
    'validDate': {
      'invalid-ValidTo': ' ValidTo date should be greater than validFrom Date',
    },
    'startDate': {
      'required': 'validFrom  is required'
    },

    'endDate': {
      'required': 'ValidTo  is required',
    },
    'providerId': {
      'required': 'Please provide atleast one provider Id ',
      'whitespace': 'Provider Id is invalid'
    },
    'maxDiscountValue': {
      'zeroOrnegativeNumber': 'Zero or Negative numbers are  not allowed'
    },
    'maxReimbursePercentage': {
      'zeroOrnegativeNumber': 'Zero or Negative numbers are  not allowed'
    },
    'maxConsumerUseLimit': {
      'required': 'value is required',
      'decimalNumber': 'Decimal Number is not accepted'
    },
    'maxConsumerUseLimitPerProvider': {
      'required': 'value is required',
      'decimalNumber': 'Decimal Number is not accepted'
    },
    'maxProviderUseLimit': {
      'required': 'value is required',
      'decimalNumber': 'Decimal Number is not accepted'
    }

  };
  ngOnInit() {
    this.commonService.getServiceSectors()
      .subscribe(res => {
        this.domains = res;
      });

    this.accountService.getLicensePackages()
      .subscribe(res => {
        this.license_packages = res;
      });
    const today = new Date().toISOString().split('T')[0];
    document.getElementsByName('setTodaysDate')[0].setAttribute('min', today);
    document.getElementsByName('setTodaysDate')[1].setAttribute('min', today);
    this.dstart_time = { hour: parseInt(moment(projectConstants.DEFAULT_STARTTIME, ['h:mm A']).format('HH'), 10), minute: parseInt(moment(projectConstants.DEFAULT_STARTTIME, ['h:mm A']).format('mm'), 10) };
    this.dend_time = { hour: parseInt(moment(projectConstants.DEFAULT_ENDTIME, ['h:mm A']).format('HH'), 10), minute: parseInt(moment(projectConstants.DEFAULT_ENDTIME, ['h:mm A']).format('mm'), 10) };
  }


  createForm() {
    this.couponForm = this.formbuilder.group({
      couponName: ['', [Validators.required, Validators.minLength(3), this.customValidator.noWhiteSpace]],
      jaldeeCouponCode: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(15),
      Validators.pattern('^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ ]+$'), this.customValidator.noWhiteSpace]],
      couponDescription: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      providerDescription: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      consumerTermsAndconditions: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      discountType: ['AMOUNT'],
      discountValue: ['', [Validators.required, this.customValidator.isPositiveNumber]],
      maxDiscountValue: ['', [this.customValidator.isPositiveNumber]],
      couponRules: this.formbuilder.group({
        startDate: ['', [Validators.required]],
        endDate: ['', [Validators.required]],
        qstarttime: [this.dstart_time],
        qendtime: [this.dend_time],
        targetDate : [''],
        minBillAmount: ['', [Validators.required, this.customValidator.isPositiveNumber]],
        limitFirstCheckin: [false],
        firstCheckin: ['FCEVER'],
        firstCheckinOnly: [false],
        firstCheckinPerProviderOnly: [false],
        limitConsumerNo: [''],
        maxConsumerUseLimit: ['', [this.customValidator.isDecimalNumber]],
        maxConsumerUseLimitPerProvider: ['', [Validators.required, this.customValidator.isDecimalNumber]],
        limitProviderNo: [''],
        limitPerProviderNo: [''],
        maxProviderUseLimit: ['', [Validators.required, this.customValidator.isDecimalNumber]],
        selfPaymentRequired: [false],
        combineWithOtherCoupon: [false],
        onlineCheckinRequired: [false],
        defaultEnabled: [false],
        alwaysEnabled: [false],
        isJaldeeReimburse: [false],
        maxReimbursePercentage: ['', [this.customValidator.isPositiveNumber]],
      }),
      target: this.formbuilder.group({
        selectedTarget: ['general'],
        licenseRequired: [],
        domain: [],
        subdomain: [],
        providerId: []
      })
    });
  }
  check_existsinweek_array(arr, val) {
    let ret = -1;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === val) {
        ret = i;
      }
    }
    return ret;
  }
  handleDaychange(index) {
    const selindx = this.selday_arr.indexOf(index);
    if (selindx === -1) {
      this.selday_arr.push(index.toString());
    } else {
      this.selday_arr.splice(selindx, 1);
    }
    if (this.selday_arr.length === 7) {
      this.selallweekdays = true;
    } else {
      this.selallweekdays = false;
    }

  }
  changetime(src, passtime) {
    switch (src) {
        case 'start':
            this.dstart_time = passtime;
            break;
        case 'end':
            this.dend_time = passtime;
            break;
    }
}
  updateForm(coupon) {
    if(coupon.couponRules.targetDate.length === 0){
      let ReimbursePercentage = ''
    if (coupon.couponRules.maxReimbursePercentage === 0){
      ReimbursePercentage = '';
    }else{
      ReimbursePercentage = coupon.couponRules.maxReimbursePercentage;
    }
    this.couponForm.patchValue({
      couponName: coupon.couponName,
      jaldeeCouponCode: coupon.jaldeeCouponCode,
      couponDescription: coupon.couponDescription,
      providerDescription: coupon.providerDescription,
      consumerTermsAndconditions: coupon.consumerTermsAndconditions,
      discountType: coupon.discountType,
      discountValue: coupon.discountValue,
      maxDiscountValue: coupon.maxDiscountValue,
     
    });
   
    this.couponForm.get('couponRules').patchValue({
      startDate: new Date(coupon.couponRules.startDate).toISOString().slice(0, 10),
      endDate: new Date(coupon.couponRules.endDate).toISOString().slice(0, 10),
      minBillAmount: coupon.couponRules.minBillAmount,
      maxConsumerUseLimit: coupon.couponRules.maxConsumerUseLimit,
      maxConsumerUseLimitPerProvider: coupon.couponRules.maxConsumerUseLimitPerProvider,
      maxProviderUseLimit: coupon.couponRules.maxProviderUseLimit,
      selfPaymentRequired: coupon.couponRules.selfPaymentRequired,
      combineWithOtherCoupon: coupon.couponRules.combineWithOtherCoupon,
      onlineCheckinRequired: coupon.couponRules.onlineCheckinRequired,
      defaultEnabled: coupon.couponRules.defaultEnabled,
      alwaysEnabled: coupon.couponRules.alwaysEnabled,
      maxReimbursePercentage: ReimbursePercentage,
     
      // qstarttime: sttime,
      // qendtime: edtime,
    });

    this.couponForm.get('target').patchValue({
      licenseRequired: coupon.target.licenseRequired || null,
      domain: coupon.target.domain || null,
      subdomain: coupon.target.subdomain || null,
      providerId: coupon.target.providerId || null

    });
    
    if (coupon.target.licenseRequired) {
      if (coupon.target.licenseRequired.includes(0)) {
        this.couponForm.get('target').get('licenseRequired').patchValue(this.getLicense(coupon.target.licenseRequired));
      }
    }
    // console.log('coupon Targets .... ' + JSON.stringify(coupon.target));
    if (coupon.target.domain) {
      this.couponForm.get('target').get('selectedTarget').setValue('general');
      /* coupon target is all*/
      if (coupon.target.domain.includes('ALL')) {
        this.couponForm.get('target').get('domain').patchValue(this.couponService.getAllServiceSectors());
        if (coupon.target.subdomain.includes('ALL')) {
          this.getSubDomainsOfDomains(this.couponService.getAllServiceSectors());
          this.couponForm.get('target').get('subdomain').patchValue(this.couponService.getAllServiceSubSectors());
        } else {
          this.getSubDomainsOfDomains(coupon.target.domain);
          this.couponForm.get('target').get('subdomain').patchValue(coupon.target.subdomain);
        }
      } /**coupon target is not all */ else {
        this.couponForm.get('target').get('domain').patchValue(coupon.target.domain);

        if (coupon.target.subdomain.includes('ALL')) {
          this.getSubDomainsOfDomains(coupon.target.domain);
          this.couponForm.get('target').get('subdomain').patchValue(this.couponService.getAllServiceSubSectors());
        } else {
          this.getSubDomainsOfDomains(coupon.target.domain);
          this.couponForm.get('target').get('subdomain').patchValue(coupon.target.subdomain);
        }
      }

    }
    if (coupon.target.providerId) {
      this.couponForm.get('target').get('selectedTarget').setValue('specific');
    }

    if ((coupon.couponRules.firstCheckinPerProviderOnly === true) || (coupon.couponRules.firstCheckInEver === true)) {
      this.couponForm.get('couponRules').get('limitFirstCheckin').setValue(true);
      if (coupon.couponRules.firstCheckinPerProviderOnly) {
        this.couponForm.get('couponRules').get('firstCheckin').setValue('FCPERPROVIDER');
      } else {
        this.couponForm.get('couponRules').get('firstCheckin').setValue('FCEVER');
      }
    }

    if (coupon.couponRules.maxProviderUseLimit > 0) {
      this.couponForm.get('couponRules').get('limitProviderNo').setValue(true);
    }
    if (coupon.couponRules.maxConsumerUseLimitPerProvider > 0) {
      this.couponForm.get('couponRules').get('limitPerProviderNo').setValue(true);
    }
    if (coupon.couponRules.maxConsumerUseLimit > 0) {
      this.couponForm.get('couponRules').get('limitConsumerNo').setValue(true);
    }
    if (coupon.couponRules.maxReimbursePercentage > 0) {
      this.couponForm.get('couponRules').get('isJaldeeReimburse').setValue(true);
    }
    }
    else{
let ReimbursePercentage = ''
    if (coupon.couponRules.maxReimbursePercentage === 0){
      ReimbursePercentage = '';
    }else{
      ReimbursePercentage = coupon.couponRules.maxReimbursePercentage;
    }
    const sttime = {
      hour: parseInt(moment(coupon.couponRules.targetDate[0].timeSlots[0].sTime, ['h:mm A']).format('HH')), minute: parseInt(moment(coupon.couponRules.targetDate[0].timeSlots[0].sTime, ['h:mm A']).format('mm')) 
  };
  const edtime = {
    hour: parseInt(moment(coupon.couponRules.targetDate[0].timeSlots[0].eTime, ['h:mm A']).format('HH')), minute: parseInt(moment(coupon.couponRules.targetDate[0].timeSlots[0].eTime, ['h:mm A']).format('mm')) 
};
    // console.log(parseInt(moment(coupon.couponRules.targetDate[0].timeSlots[0].sTime, ['h:mm A']).format('HH'))),
    //   console.log(parseInt(moment(coupon.couponRules.targetDate[0].timeSlots[0].sTime, ['h:mm A']).format('mm'))),
    //   console.log(parseInt(moment(coupon.couponRules.targetDate[0].timeSlots[0].eTime, ['h:mm A']).format('HH'))),
    //   console.log(parseInt(moment(coupon.couponRules.targetDate[0].timeSlots[0].eTime, ['h:mm A']).format('mm'))),
    this.couponForm.patchValue({
      couponName: coupon.couponName,
      jaldeeCouponCode: coupon.jaldeeCouponCode,
      couponDescription: coupon.couponDescription,
      providerDescription: coupon.providerDescription,
      consumerTermsAndconditions: coupon.consumerTermsAndconditions,
      discountType: coupon.discountType,
      discountValue: coupon.discountValue,
      maxDiscountValue: coupon.maxDiscountValue,
     
    });
   
    this.couponForm.get('couponRules').patchValue({
      startDate: new Date(coupon.couponRules.startDate).toISOString().slice(0, 10),
      endDate: new Date(coupon.couponRules.endDate).toISOString().slice(0, 10),
      minBillAmount: coupon.couponRules.minBillAmount,
      maxConsumerUseLimit: coupon.couponRules.maxConsumerUseLimit,
      maxConsumerUseLimitPerProvider: coupon.couponRules.maxConsumerUseLimitPerProvider,
      maxProviderUseLimit: coupon.couponRules.maxProviderUseLimit,
      selfPaymentRequired: coupon.couponRules.selfPaymentRequired,
      combineWithOtherCoupon: coupon.couponRules.combineWithOtherCoupon,
      onlineCheckinRequired: coupon.couponRules.onlineCheckinRequired,
      defaultEnabled: coupon.couponRules.defaultEnabled,
      alwaysEnabled: coupon.couponRules.alwaysEnabled,
      maxReimbursePercentage: ReimbursePercentage,
     
      qstarttime: sttime,
      qendtime: edtime,
    });

    this.couponForm.get('target').patchValue({
      licenseRequired: coupon.target.licenseRequired || null,
      domain: coupon.target.domain || null,
      subdomain: coupon.target.subdomain || null,
      providerId: coupon.target.providerId || null

    });
    this.selday_arr = [];
    for (let j = 0; j < coupon.couponRules.targetDate[0].repeatIntervals.length; j++) {
        this.selday_arr.push(Number(coupon.couponRules.targetDate[0].repeatIntervals[j]));
    }
    if (this.selday_arr.length === 7) {
        this.Selall = true;
    } else {
        this.Selall = false;
    }
    if (coupon.target.licenseRequired) {
      if (coupon.target.licenseRequired.includes(0)) {
        this.couponForm.get('target').get('licenseRequired').patchValue(this.getLicense(coupon.target.licenseRequired));
      }
    }
    // console.log('coupon Targets .... ' + JSON.stringify(coupon.target));
    if (coupon.target.domain) {
      this.couponForm.get('target').get('selectedTarget').setValue('general');
      /* coupon target is all*/
      if (coupon.target.domain.includes('ALL')) {
        this.couponForm.get('target').get('domain').patchValue(this.couponService.getAllServiceSectors());
        if (coupon.target.subdomain.includes('ALL')) {
          this.getSubDomainsOfDomains(this.couponService.getAllServiceSectors());
          this.couponForm.get('target').get('subdomain').patchValue(this.couponService.getAllServiceSubSectors());
        } else {
          this.getSubDomainsOfDomains(coupon.target.domain);
          this.couponForm.get('target').get('subdomain').patchValue(coupon.target.subdomain);
        }
      } /**coupon target is not all */ else {
        this.couponForm.get('target').get('domain').patchValue(coupon.target.domain);

        if (coupon.target.subdomain.includes('ALL')) {
          this.getSubDomainsOfDomains(coupon.target.domain);
          this.couponForm.get('target').get('subdomain').patchValue(this.couponService.getAllServiceSubSectors());
        } else {
          this.getSubDomainsOfDomains(coupon.target.domain);
          this.couponForm.get('target').get('subdomain').patchValue(coupon.target.subdomain);
        }
      }

    }
    if (coupon.target.providerId) {
      this.couponForm.get('target').get('selectedTarget').setValue('specific');
    }

    if ((coupon.couponRules.firstCheckinPerProviderOnly === true) || (coupon.couponRules.firstCheckInEver === true)) {
      this.couponForm.get('couponRules').get('limitFirstCheckin').setValue(true);
      if (coupon.couponRules.firstCheckinPerProviderOnly) {
        this.couponForm.get('couponRules').get('firstCheckin').setValue('FCPERPROVIDER');
      } else {
        this.couponForm.get('couponRules').get('firstCheckin').setValue('FCEVER');
      }
    }

    if (coupon.couponRules.maxProviderUseLimit > 0) {
      this.couponForm.get('couponRules').get('limitProviderNo').setValue(true);
    }
    if (coupon.couponRules.maxConsumerUseLimitPerProvider > 0) {
      this.couponForm.get('couponRules').get('limitPerProviderNo').setValue(true);
    }
    if (coupon.couponRules.maxConsumerUseLimit > 0) {
      this.couponForm.get('couponRules').get('limitConsumerNo').setValue(true);
    }
    if (coupon.couponRules.maxReimbursePercentage > 0) {
      this.couponForm.get('couponRules').get('isJaldeeReimburse').setValue(true);
    }
    }
    

  }
  // license toggle all(select option)
  toggleAllLicenseSelection() {
    if (this.allLicenseSelected.selected) {
      this.couponForm.get('target').get('licenseRequired')
        .patchValue([...this.license_packages.map(license => license.pkgId), 0]);
    } else {
      this.couponForm.get('target').get('licenseRequired').setValue([]);
    }
  }

  tossleLicensePerOne(all) {
    if (this.allLicenseSelected.selected) {
      this.allLicenseSelected.deselect();
      return false;
    }
    if (this.couponForm.get('target').get('licenseRequired').value.length === this.license_packages.length) {
      this.allLicenseSelected.select();
    }
  }
  // domain toggle all (select option)
  toggleAllDomainSelection() {
    if (this.allDomainSelected.selected) {
      this.couponForm.get('target').get('domain')
        .patchValue([...this.domains.map(domain => domain.domain), 0]);
      this.allSubDomainSelected.select();
      this.toggleAllSubDomainSelection();
    } else {
      this.couponForm.get('target').get('domain').setValue([]);
      this.couponForm.get('target').get('subdomain').setValue([]);
    }
  }

  tossleDomainPerOne(all) {
    if (this.allDomainSelected.selected) {
      this.allDomainSelected.deselect();
      // this.allSubDomainSelected.select();
      // this.toggleAllSubDomainSelection();
      return false;
    }
    if (this.couponForm.get('target').get('domain').value.length === this.domains.length) {
      this.allDomainSelected.select();

    }
  }

  // subdomain toggle all (select option)
  toggleAllSubDomainSelection() {
    if (this.allSubDomainSelected.selected) {
      this.couponForm.get('target').get('subdomain')
        .patchValue([...this.subDomains.map(subDomain => subDomain.subDomain), 0]);
    } else {
      this.couponForm.get('target').get('subdomain').setValue([]);
    }
  }

  tossleSubDomainPerOne(all) {
    if (this.allSubDomainSelected.selected) {
      this.allSubDomainSelected.deselect();
      return false;
    }
    if (this.couponForm.get('target').get('subdomain').value.length === this.subDomains.length) {
      this.allSubDomainSelected.select();
    }
  }

  logValidationErrors(group: UntypedFormGroup = this.couponForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (abstractControl && !abstractControl.valid &&
        (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.ValidationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof UntypedFormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });


  }
  markFormGroupTouched(group: UntypedFormGroup = this.couponForm) {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      abstractControl.markAsTouched();
      if (abstractControl instanceof UntypedFormGroup) {
        this.markFormGroupTouched(abstractControl);
      }
    });
    this.logValidationErrors();

  }

  OnCouponSubmit() {
    
    if (this.couponForm.invalid) {
      console.log(this.couponForm.invalid)
      this.api_error = 'Please fill all the required fields of coupon';
      this.markFormGroupTouched();
    } else {
      const daystr: any = [];
      // const today = cdate.getFullYear() + '-' + mon + '-' + cdate.getDate();
      for (const cday of this.selday_arr) {
        daystr.push(cday);
       
      }
      console.log(this.data);
      const couponCode = this.couponForm.get('jaldeeCouponCode').value;
      if (this.data['status'] === 'ACTIVE') {
        const validToDate = this.couponForm.get('couponRules').get('endDate').value;
        const couponName = this.couponForm.get('couponName').value;
        const provider_description = this.couponForm.get('providerDescription').value;
        const consumerTermsAndconditions = this.couponForm.get('consumerTermsAndconditions').value;
        const couponDescription = this.couponForm.get('couponDescription').value;
        const curdate = new Date();
        curdate.setHours(this.dstart_time.hour);
        curdate.setMinutes(this.dstart_time.minute);
        const enddate = new Date();
        enddate.setHours(this.dend_time.hour);
        enddate.setMinutes(this.dend_time.minute);
        const starttime_format = moment(curdate).format('hh:mm A') || null;
        const endtime_format = moment(enddate).format('hh:mm A') || null;
        const timeRangeObject = [{
          'recurringType': 'Weekly',
          'repeatIntervals': daystr,
          // 'timeSlots': this.timewindow_list,
          'startDate': this.couponForm.get('couponRules').get('startDate').value,
          "timeSlots": [{
            "eTime": endtime_format,
            "sTime": starttime_format
          }],
          'terminator': {
            'endDate': this.couponForm.get('couponRules').get('endDate').value,
            'noOfOccurance': ''
          },
        }];
        const data = {
          'newEndDate': validToDate,
          'couponName': couponName,
          'providerDescription': provider_description,
          'consumerTermsAndconditions': consumerTermsAndconditions,
          'couponDescription': couponDescription,
          'couponRules': {targetDate:timeRangeObject}
        };
        this.onUpdateCoupon(data, couponCode);

      } else {
        this.couponForm.get('jaldeeCouponCode').enable();
        this.couponForm.get('couponRules').get('defaultEnabled').enable();
        const form_data = this.couponForm.value;
        if (this.couponForm.get('couponRules').get('limitFirstCheckin').value === false) {
          form_data.couponRules.firstCheckinOnly = false;
          form_data.couponRules.firstCheckinPerProviderOnly = false;

        } else {
          if (this.couponForm.get('couponRules').get('firstCheckin').value === 'FCEVER') {
            form_data.couponRules.firstCheckinOnly = true;
            form_data.couponRules.maxConsumerUseLimitPerProvider = 1;
            form_data.couponRules.maxConsumerUseLimit = 1;
          } else if (this.couponForm.get('couponRules').get('firstCheckin').value === 'FCPERPROVIDER') {
            form_data.couponRules.firstCheckinPerProviderOnly = true;
            form_data.couponRules.maxConsumerUseLimitPerProvider = 1;

          }

        }
        const curdate = new Date();
            curdate.setHours(this.dstart_time.hour);
            curdate.setMinutes(this.dstart_time.minute);
            const enddate = new Date();
            enddate.setHours(this.dend_time.hour);
            enddate.setMinutes(this.dend_time.minute);
            const starttime_format = moment(curdate).format('hh:mm A') || null;
            const endtime_format = moment(enddate).format('hh:mm A') || null;
        const timeRangeObject = [{
          'recurringType': 'Weekly',
          'repeatIntervals': daystr,
          // 'timeSlots': this.timewindow_list,
          'startDate': form_data.couponRules.startDate,
          "timeSlots": [{
            "eTime": endtime_format,
            "sTime": starttime_format
          }],
          'terminator': {
            'endDate': form_data.couponRules.endDate,
            'noOfOccurance': ''
          },
        }];
        form_data.couponRules.targetDate  = timeRangeObject;
        
        if (form_data.discountType === 'AMOUNT') {
          form_data.maxDiscountValue = form_data.discountValue;

        }
        if (form_data.couponRules.alwaysEnabled.value === true) {
          form_data.couponRules.defaultEnabled = true;
        }
        
        if (form_data.couponRules.isJaldeeReimburse === false) {
          form_data.couponRules.maxReimbursePercentage = '';
        }
        if (this.couponForm.get('target').get('selectedTarget').value === 'specific') {
          if (form_data.target.providerId != null) {
            let providerArray = [];
            if (form_data.target.providerId.includes(',')) {
              providerArray = this.couponForm.get('target').get('providerId').value.split(',').map(Number);
            } else {
              providerArray.push(parseInt(this.couponForm.get('target').get('providerId').value, 10));
            }
            form_data.target.providerId = providerArray;

          } else {
            delete form_data.target.providerId;
          }
          delete form_data.target.domain;
          delete form_data.target.subdomain;
          delete form_data.target.licenseRequired;
        } else {
          if (form_data.target.domain === null || form_data.target.domain.length === 0) {
            delete form_data.target.domain;
            // if (form_data.target.subdomain === null || form_data.target.subdomain.length === 0) {
            delete form_data.target.subdomain;

            // }
          } else if (form_data.target.domain != null || form_data.target.domain.length !== 0) {
            if (form_data.target.domain.includes(0)) {
              form_data.target.domain = ['ALL'];
            }
            if (form_data.target.subdomain.includes(0) || form_data.target.subdomain.length === 0 || form_data.target.domain === null) {
              console.log('subdoamin is going to set all......' + form_data.target.subdomain);
              form_data.target.subdomain = ['ALL'];
            }
            //  }
          }
          console.log('licenseRequired' + form_data.target.licenseRequired);

          if (form_data.target.licenseRequired === null || form_data.target.licenseRequired.length === 0) {
            delete form_data.target.licenseRequired;
          } else if (form_data.target.licenseRequired.includes(0)) {
            form_data.target.licenseRequired = [0];
          }

          delete form_data.target.providerId;
        }
        delete form_data.target.selectedTarget;
        delete form_data.couponRules.limitFirstCheckin;
        delete form_data.couponRules.firstCheckin;
        delete form_data.couponRules.limitConsumerNo;
        delete form_data.couponRules.limitProviderNo;
        delete form_data.couponRules.limitPerProviderNo;
        delete form_data.couponRules.isJaldeeReimburse;
        if (this.data['type'] === 'edit') {
          this.onUpdateCoupon(form_data, couponCode);

        } else {
          console.log('form_data before submit' + form_data);
          this.createCoupon(form_data);
        }
      }
    }
  }
  onIsJaldeeReimburseChanged(){
    let FC_Value = this.couponForm.get('couponRules').get('isJaldeeReimburse').value;
    // alert(FC_Value)
    if(!FC_Value){
      console.log(this.couponForm)
      //this.couponForm.invalid === false
      this.couponForm.get('invalid').reset({ value: false, disabled: false });
      //this.couponForm.controls['invalid'].setValue(false);
      console.log(this.couponForm)
      this.couponForm.value.couponRules.maxReimbursePercentage = '';
    }
  }
  onUpdateCoupon(data, couponCode) {
    this.api_error = '';
    this.couponService.updateJaldeeCoupon(data, couponCode)
      .subscribe(res => {
        this.api_success = 'Jaldee Coupon Updated Successfully';
        setTimeout(() => {
          this.matDialog.close();
        }, 2000);
      },
        (error) => {
          this.api_error = error.error;
        });

  }
  createCoupon(data) {
    console.log('daya' + data);
    this.api_error = '';
    this.couponService.createJaldeeCoupon(data)
      .subscribe(res => {
        this.api_success = 'Jaldee Coupon Created Successfully';
        setTimeout(() => {
          this.matDialog.close();
        }, 2000);
      },
        (error) => {
          this.api_error = error.error;
        }
      );
  }
  setLimit(): void {
    const val = this.couponForm.get('couponRules').get('limitFirstCheckin').value;
    if (val === true) {
      this.couponForm.get('couponRules').get('limitConsumerNo').reset({ value: true, disabled: true });
      this.maxLimitperProvider = true;
      this.couponForm.get('couponRules').get('limitPerProviderNo').reset({ value: true, disabled: true });
      this.couponForm.get('couponRules').get('maxConsumerUseLimitPerProvider').reset({ value: '1', disabled: true });
      this.couponForm.get('couponRules').get('maxConsumerUseLimit').reset({ value: '1', disabled: true });

    } else {
      this.couponForm.get('couponRules').get('limitConsumerNo').reset({ value: false, disabled: false });
      this.maxLimitperProvider = false;
      this.couponForm.get('couponRules').get('maxConsumerUseLimitPerProvider').reset({ value: '', disabled: false });
      this.couponForm.get('couponRules').get('maxConsumerUseLimit').reset({ value: '', disabled: false });
      this.couponForm.get('couponRules').get('limitPerProviderNo').reset({ value: false, disabled: false });
    }

  }

  OnFirstCheckInChange() {
    const FC_Value = this.couponForm.get('couponRules').get('firstCheckin').value;
    if (FC_Value === 'FCPERPROVIDER') {
      this.couponForm.get('couponRules').get('limitConsumerNo').reset({ value: false, disabled: false });
      this.couponForm.get('couponRules').get('maxConsumerUseLimit').reset({ value: '', disabled: false });
    } else {
      this.hideConsumerLimit = true;
      this.couponForm.get('couponRules').get('limitConsumerNo').reset({ value: true, disabled: true });
      this.couponForm.get('couponRules').get('maxConsumerUseLimit').reset({ value: 1, disabled: true });
    }

  }
  onDomainChange(event) {
    this.subDomains = [];
    this.selectedDomains = [];
    if (event.includes(0)) {
      this.selectedDomains = this.couponService.getAllDomainsId(this.domains);
    } else {
      this.selectedDomains = event.toString().split(',');
    }
    for (let a = 0; a < this.selectedDomains.length; a++) {
      for (let i = 0; i < this.domains.length; i++) {
        // tslint:disable-next-line:triple-equals
        if (this.selectedDomains[a] === this.domains[i].domain) {
          this.domain = this.domains[i].domain;
          for (let j = 0; j < this.domains[i].subDomains.length; j++) {
            this.subDomains.push({
              'displayName': this.domains[i].subDomains[j].displayName,
              'id': this.domains[i].subDomains[j].id, 'subDomain': this.domains[i].domain + '_' + this.domains[i].subDomains[j].subDomain
            });
            console.log(this.subDomains)
          }
        }
      }
    }
    this.allSubDomainSelected.select();
    this.toggleAllSubDomainSelection();
  }

  getSubDomainsOfDomains(selected_domains) {
    this.commonService.getServiceSectors()
      .subscribe(res => {
        this.domains = res;
        this.subDomains = [];
        this.selectedDomains = [];
        this.selectedDomains = selected_domains;
        for (let a = 0; a < this.selectedDomains.length; a++) {
          for (let i = 0; i < this.domains.length; i++) {
            if (this.selectedDomains[a] === this.domains[i].domain) {
              this.domain = this.domains[i].domain;
              for (let j = 0; j < this.domains[i].subDomains.length; j++) {
                this.subDomains.push({
                  'displayName': this.domains[i].subDomains[j].displayName,
                  'id': this.domains[i].subDomains[j].id, 'subDomain': this.domains[i].domain + '_'
                    + this.domains[i].subDomains[j].subDomain
                });
              }
            }
          }
        }
      });
  }
  getLicense(licenses) {
    const licensePkgId = [];
    if (licenses.includes(0)) {
      licensePkgId.push(0);
      this.accountService.getLicensePackages()
        .subscribe(res => {
          this.license_packages = res;
          for (let i = 0; i < this.license_packages.length; i++) {
            licensePkgId.push(this.license_packages[i].pkgId);

          }
        });

    }
    return licensePkgId;
  }
  isValidateDate(): { [key: string]: any } | null {
    const validFromcontrol = this.couponForm.get('couponRules').get('startDate');
    const validTocontrol = this.couponForm.get('couponRules').get('endDate');
    if ((validFromcontrol !== null && validTocontrol !== null) && validTocontrol.value > validFromcontrol.value) {
      console.log('wrong entry');
      return null;
    } else {
      console.log(this.ValidationMessages['invalid-ValidTo']);
      return this.formErrors['validDate'] = this.ValidationMessages['invalid-ValidTo'];
    }
  }


  setDefaultEnabled() {
    const alwaysEnabled = this.couponForm.get('couponRules').get('alwaysEnabled').value;
    if (alwaysEnabled === true) {
      this.couponForm.get('couponRules').get('defaultEnabled').reset({ value: true, disabled: true });
    } else {
      this.couponForm.get('couponRules').get('defaultEnabled').reset({ value: false, disabled: false });
    }

  }
  onKeyProviderId(event) {
    //this.hideCheckbtn = false;
    console.log('event fired');
  }

  checkProviderId() {
    this.hide_specific_provider_info = false;
    console.log(this.couponForm.get('target').get('providerId').value);
    this.providerIds.push(this.couponForm.get('target').get('providerId').value.split(','));
    // alert(this.providerIds);
    // this.accountService.getMinimalAccountInfo(this.providerIds)
    // .subscribe(res => {
    // this.accounts= 
    //    [{
    //     "id": 1,
    //     "businessName": "Two Wheelers",
    //     "location": "Thrissur",
    //     "license_pkg": "Diamond",
    //     "domain": "HealthCare",
    //     "subDomain": "Physicians"
    //   }, {
    //     "id": 2,
    //     "businessName": "Auto Garage",
    //     "location": "Thrissur",
    //     "license_pkg": "Gold",
    //     "domain": "AutoMobiles",
    //     "subDomain": "AutoRepair"
    //   }];

    // },
    // (error) => {
    //  console.log('error.error');
    // });
  }

}


